import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components";

import DurationService from "app/services/DurationService";

import { useCategories } from "../../../../categories-context/CategoriesContext";
import { useKeyIndicatorsData } from "../hooks/useKeyIndicatorsData";

import KeyIndicators from "./key-indicators/KeyIndicators";
import KeyIndicatorsPop from "./key-indicators-pop/KeyIndicatorsPop";

const KeyIndicatorsWrapper = styled(Box)<{ wrapperWidth: string; wrapperHeight: string }>`
    background-color: ${colorsPalettes.carbon[0]};
    height: ${({ wrapperHeight }) => `${wrapperHeight}`};
    width: ${({ wrapperWidth }) => `${wrapperWidth}`};
`;

interface IKeyIndicators {
    width?: string;
    height?: string;
}

const KeyIndicatorsContainer: FC<IKeyIndicators> = ({ width = "100%", height = "368px" }) => {
    const { categories } = useCategories();
    const primaryCategory = categories[0]?.category;
    const { data, isLoading } = useKeyIndicatorsData(primaryCategory ? [primaryCategory] : []);
    const isPop = DurationService.isPeriodOverPeriod();

    const primaryData = data[0];
    const rawData = primaryData?.rawData;
    const rawDataPop = primaryData?.rawDataPop;

    return (
        <KeyIndicatorsWrapper
            data-automation="KeyIndicators"
            wrapperWidth={width}
            wrapperHeight={height}
        >
            {isPop ? (
                <KeyIndicatorsPop
                    dataPop={rawDataPop}
                    isLoading={isLoading}
                />
            ) : (
                <KeyIndicators
                    data={rawData}
                    isLoading={isLoading}
                />
            )}
        </KeyIndicatorsWrapper>
    );
};

export default KeyIndicatorsContainer;
